<template>
<div>
	<div class="align_with_tab">
		<span class="row mb-2 pointer">
			<router-link v-if="user_view != 'csm'" :to="{ name : 'organization.courses.index'}">
				<img class="" src="../../../assets/images/u315.svg"/> Back to Program list
			</router-link>
		</span>
		<span class="bold-title row mb-2 pointer"> {{course_data.name}}</span>
		<span class="normal-title row time-section mt-2 mb-2"> <img class="img-font-size mr-2" id="" src="../../../assets/images/access_time_u27.svg"/> {{secondsToHms(course_data.duration,false)}}</span>
		<span class="normal-title description-section row mt-2 mb-2"> {{course_data.description}} </span>
	</div>

	<b-tabs card class="tab-position" v-model="tabIndex">
		<b-tab class="" title="Program Detail">
			<organization-course-module-detail :course_data="course_data">
			</organization-course-module-detail>
		</b-tab>
		<b-tab v-if="course_data.in_class" title="Sessions" class="padding-half">
			<div class="display-flex-row table-group">
				<div class="flex">
					<h3>Sessions</h3>

					<button class="print-button print-color margin-left button width-auto" @click="openCreateSession()"><img class="mr-1" src="../../../assets/images/icons/solid/plus-circle-white.svg" width="13"/> Create Session  </button>
				</div>

				<div class="table-border">
					<h5>Active</h5>
					<session-table-view class="mb-3" @getSessionList="getSessionList"  @openViewSession="openViewSession" :headers="active_headers" :body="active_list" :section="'active'" />
					<div class="empty_frame" v-if="active_list.length == 0">
						<h6 class="session_empty_record">No records have found</h6>
					</div>
				</div>
				<div class="table-border">

					<h5>Scheduled</h5>
					<session-table-view class="mb-3 mt-3" @getSessionList="getSessionList" @openViewSession="openViewSession" :headers="active_headers" :body="scheduled_list" :section="'scheduled'"/>

					<div class="empty_frame" v-if="scheduled_list.length == 0">
						<h6 class="session_empty_record">No records have found</h6>
					</div>
				</div>
				<div class="table-border">	
					<h5>Completed</h5>
					
						<session-table-view class="mb-3" @getSessionList="getSessionList" @openViewSession="openViewSession" :headers="completed_headers" :body="completed_list" :section="'completed'"/>
						<div class="empty_frame" v-if="completed_list.length == 0">
							<h6 class="session_empty_record">No records have found</h6>
						</div>
					</div>
				</div>

			<!-- </div> -->
			<!-- <organization-course-session-create v-if="show_create_session" /> -->
		</b-tab>
	</b-tabs>

	<div class="align_with_tab">
		<span id="UUID" class="row mt-2 mb-2">API ID: {{ course_data.uuid ? course_data.uuid : ''}}
		</span>
	</div>
</div>
	
</template>
<script >
import sessionTableView from '../../shared/sessionTableView'
import OrganizationCourseModuleDetail from './OrganizationCourseModuleDetail.vue'
import OrganizationCourseSessionCreate from './OrganizationCourseSessionCreate.vue'
import MixinSME from '../../sme/MixinSME';
import SessionCreateView from '../../shared/sessionCreateView'
export default {
	components : {
		OrganizationCourseModuleDetail,
		SessionCreateView,
		OrganizationCourseSessionCreate,
		sessionTableView
	},
	mixins: [MixinSME],
	data: function(){
		return{
			id: this.$route.params.id,
			course_data: {},
			tabIndex:null,
			show_create_session: false,
			active_headers:[
				'Session Name','Supervisor', 'Scheduled To','Participants', 'Actions'
			],
			scheduled_headers:[
				'Session Name','Supervisor', 'Scheduled To','Participants', 'Start Session'
			],
			completed_headers:[
				'Session Name','Supervisor', 'Scheduled To','Participants', 'Session Date', 'All Certificates', 'All Reports'
			],
			scheduled_list:[],
			completed_list:[],
			active_list:[],
		}
	},
	computed : {
		user_view(){
			return this.$store.getters.getRole
		}
	},
	watch:{
		tabIndex: function(index){
			let section_query = '';
			this.show_create_session = false;
			switch(index){
				case 0:
					section_query = 'detail';
					break;
		       case 1:
					section_query = 'sessions';
					this.getSessionList()
			}
			if(this.user_view == 'csm'){
				window.history.pushState({},'',`/admin/programs/${this.$route.params.id}/${section_query}/${this.$route.params.agency_id}`)
			}else{
				window.history.pushState({},'',`/o/programs/${this.$route.params.id}/${section_query}`)
			}
		},
		 '$route.params.section': {
			handler: function(search) {
				console.log(search)
				if(search == 'sessions'){
					this.tabIndex = 1
				}else{
					this.tabIndex = 0
				}
			},
			deep: true,
			immediate: true
		}
	},
	created : function(){
		this.getCourseDetail()
	},
	methods : {
		openCreateSession(){
			this.show_create_session = true;
			if(this.user_view == 'csm'){
				this.$router.push({ name :'admin.courses.session', params:{ id: this.$route.params.id, agency_id:this.$route.params.agency_id }})
			}else{
				this.$router.push({ name :'organization.courses.session', params:{ id: this.$route.params.id }})
			}
		},
		openViewSession(id){
			if(this.user_view == 'csm'){
				this.$router.push({ name :'admin.courses.session_detail', params:{ id: this.$route.params.id, session_id: id, agency_id:this.$route.params.agency_id }})
			}else{
				this.$router.push({ name :'organization.courses.session_detail', params:{ id: this.$route.params.id, session_id: id }})
			}
		},
		getSessionList(){
			this.resetLists()
			var params = {
				course_id: this.$route.params.id,
				id: this.$route.params.agency_id || '_',
			}
		
			this.$store.dispatch('getSessions', params).then((res) => {
				res.data.data.forEach(elem => {
					switch(elem.status){
						case 'Scheduled':
							this.scheduled_list.push(elem)
							break;
						case 'Completed':
							this.completed_list.push(elem)
							break;
						case 'Active':
							this.active_list.push(elem)
							break;
					}
					
				})
			}).catch((error) => {
				console.log(error.resolve)
			})

			
			
		},
		getCourseDetail: function(){
			var params = {
				id : this.id,
				filters : {
					page_loading : true,
					full: true
				}
			}

			this.$store.dispatch('getCourse', params).then((res) => {
				this.course_data = res.data.data;
			
			}).catch((error) => {
				console.log(error);
			});
		},
		resetLists(){
			this.scheduled_list = []
			this.completed_list = []
			this.active_list = []
		},
		collapseModule: function(index){

			if (this.isOpen.includes(index)) {
				this.isOpen = this.isOpen.filter(i => i !== index);
				return;
			}

			this.isOpen.push(index);
			
		},
		collapseAll(){
			if(this.isOpen.length == 0){
				this.allOpen = true
				this.course_data.modules.forEach((elem, index) =>{
					this.isOpen.push(index)
				})
			}else{
				this.isOpen = []
				this.allOpen = false
			}
		},
		descriptionSeperator(text){
			if(text != null){
				return text.split(';')
			}else{
				return ''
			}
		},
		downloadCatalog: function(){
			var params = {
				id: this.id,
				filters : {
				}
			}
			if(this.$store.getters.getRole == 'csm'){
				params.filters.organization_id = this.$route.params.agency_id
			}
			params.filters.download_token= this.download_token
			this.$store.dispatch('downloadCatalog', params).then((res) =>{
				var url = this.config.DOWNLOAD_PROGRAM_CATALOG.replace('%COURSE_ID%', this.id);
				url = url + '?download_token='+this.download_token;
				url = url + '&organization_id='+this.$route.params.agency_id;
				window.open(url, '_self')
			})

		},
	}

}
</script>
<style scoped src="./organizationcourse.css">
#UUID { 
	font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/organizations/courses/OrganizationCourseDetailComponent2.vue